export default __webpack_public_path__ + "static/media/Test_Data.3e6f9bbe.png";